var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content_wrapper"},[_c('p',[_c('ul',{staticStyle:{"list-style":"none"}},_vm._l((_vm.pdfs),function(pdf){return _c('li',{key:pdf.id},[_c('a',{attrs:{"href":pdf.link}},[_vm._v(_vm._s(pdf.filename))])])}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }